<template>
    <section class="status">
        <div class="panel">
            <div class="panel-heading">
                <h2>My Status</h2>
            </div>
            <div v-if="loading" class="panel-body">
                <h2 class="text-center loading">Loading Data</h2>
            </div>
            <div v-else class="panel-body">
                <form>                                        
                    <div class="form-group">    
                    
                    <div v-if="selectedEnrollment">
                        <div v-for="letter in selectedEnrollment.letters">
                            
                            <a href="#" @click.prevent="downloadLetter(letter.url)">{{letter.type.split('_')[0] | capitalize}} Letter<span v-if="letter.programId"> - {{getProgramName(letter.programId)}}</span></a>
                            
                        </div>
                    </div>  
                      
<!--                         <div v-if="enrollmentLetters && enrollmentLetters.length">
                            <div v-for="letter in enrollmentLetters">
                                <a href="#" @click.prevent="downloadLetter(letter.url)">Enrollment Letter<span v-if="letter.programId"> - {{getProgramName(letter.programId)}}</span></a>                                
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="extraEnrollmentLetters && extraEnrollmentLetters > 0">
                                <a class="enrollment-letter" v-for="n in extraEnrollmentLetters + 1" href="#" @click.prevent="downloadEnrollmentLetter(n)">Enrollment Letter #{{n}}</a>
                            </div>
                            <a v-else href="#" @click.prevent="downloadEnrollmentLetter()">Enrollment Letter</a>
                        </div>
 -->


                        <div v-for="document in documents">
                            <a href="#" @click.prevent="downloadSlip(document)">{{document.type}}</a>
                        </div>
                    </div>                    
                    <div class="form-group" v-for="(project, $index) in projects">
                        <div class="diploma-links" v-if="project.passed === true &&selectedEnrollment.program.venue === 'online'">
                            <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'.pdf'" _target="blank">
                                Digital Credentials (dark)
                            </a>
                            <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'_print.pdf'" _target="blank">
                                Digital Credentials (light)
                            </a>
                        </div>
                    </div>
                   
                    <div class="form-group" v-if="loaded">
                        <div class="zoom-status">
                            <div class="indicator" :class="{'red':!zoomAccountConnected,'green':zoomAccountConnected}"></div>
                            <span v-if="zoomAccountConnected">Zoom account connected</span>
                            <span v-else>Zoom account not connected -- please contact support</span>
                        </div>
                    </div>
                    <div class="form-group" v-if="programId !== '1d8cb5a0-13b5-4ee1-a9a7-9c29566c0bbc'">
                        <!-- Do not show this section for CG Fundamentals students -->
                        <label>Your Picks</label>
                        <div class="indent" v-if="this.path != '9200'"><span class="bold">Pick Your Path:</span> <span v-if="pathName">{{pathName}}</span></div>
                        <div class="indent"><span class="bold">Pick Your Mentor: </span> <span v-if="mentorName">{{mentorName}}</span> </div>
                    </div>
                    <div class="form-group" v-if="metrics">
                        <label>All Transcripts</label>
                        <div class="download-transcript" v-if="enrollments">
                            <div v-for="enrollment in enrollments" @click.prevent="getTranscript(enrollment)">
                                Download Transcript for {{enrollment.program.name}} &ndash; {{enrollment.intake | monthAndYear}}
                            </div>
                        </div>
                        <label>Your Marks</label>
                        
                        <div class="metrics-container">
                            
                            <div v-for="metric in metrics" v-if="metric.term.type !== 'mentorship'" class="term-metrics">
                                <div @click="toggleTerm(metric.term.id)" class="term-header">
                                    <i v-if="selectedTerms.includes(metric.term.id)" class="fa fa-caret-down"></i>
                                    <i v-else class="fa fa-caret-right"></i>
                                    {{metric.term.name}}
                                    <span class="total-mark" v-if="new Date(metric.term.endDate) < new Date()">
                                        {{metric.totalMark}}%&nbsp;&nbsp;{{letterGrade(metric.totalMark)}}
                                    </span>
                                </div>
                                <div v-show="selectedTerms.includes(metric.term.id)" class="metrics">
                                    <div>
                                        <span class="bold" v-if="usesNewMarkingSystem(metric)">10% Live Session Attendance</span>
                                        <span class="bold" v-else>25% Metrics</span>

                                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">10% Video Progress: <span class="mark">{{metric.video.mark}}% {{metric.video.progress}} / {{metric.video.totalDuration}}</span></div>
                                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">5% Forum / Chat: <span class="mark">{{metric.interactions.mark}}%</span></div>
                                        <div class="indent clearfix">Attendance: <span class="mark">{{metric.meetings.attended}} / {{metric.meetings.total}}</span></div>
                                    </div>
                                    <div class="clearfix">
                                        <span @click="toggleAssignments(metric.term.id)">

                                            <span class="bold" v-if="usesNewMarkingSystem(metric)">40% Assignments:</span>
                                            <span class="bold" v-else>25% Assignments:</span>
                                            <i v-if="selectedAssignments.includes(metric.term.id)" class="fa fa-caret-down"></i>
                                            <i v-else class="fa fa-caret-right"></i>
                                        </span>
                                        <span class="mark">{{metric.assignments.mark}}%</span>
                                        <div class="submissions" v-show="selectedAssignments.includes(metric.term.id)">
                                            <div v-for="assignment in metric.assignments.assignments">                                                
                                                Week {{assignment.week}}:
                                                <span v-if="assignment.instance['associated.name']">{{assignment.instance['associated.name']}}</span>
                                                &ndash; {{assignment.name}}
                                                <!-- <pre>{{assignment.submission}}</pre> -->
                                                <span class="mark" v-if="assignment.submission">                                                    
                                                    <span v-if="assignment.submission.grade == null">Ungraded</span>
                                                    <span v-else>{{assignment.submission.grade}}</span>
                                                    <span v-if="assignment.submission.grade != null">%</span>
                                                </span>
                                                <span v-else class="mark">Incomplete</span>
                                                <span class="mark" v-else="Not Submitted"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix">
                                        <span class="bold">50% Final Project:</span> 
                                        <span v-if="metric.finalProject && new Date(metric.term.endDate) < new Date()" class="mark">
                                            <span v-if="metric.finalProject.submission && isNaN(metric.finalProject.mark)">Ungraded</span>
                                            <span v-if="!metric.finalProject.submission">Incomplete</span>
                                            <span v-if="metric.finalProject.submission && metric.finalProject.mark">
                                                {{metric.finalProject.mark}}%
                                            </span>
                                        </span>
                                    </div>
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div @click="showOverlay=false" class="overlay" v-if="showOverlay">
            <div class="not-allowed">
                <span class="close">&times;</span>
                <div class="text" @click.stop>
                    The ability to change your status is currently closed, please check your 
                    <router-link to="/journey">Journey</router-link> for when it will open.<br><br>
                    If you need to make any changes outside our status window, please create 
                    a <router-link to="/help">Financial Ticket</router-link> and outline your situation.                    
                </div>
            </div>
        </div>

        <div @click="showStatusChangePopup = false" class="overlay" v-if="showStatusChangePopup">
            <div class="not-allowed">
                <span class="close">&times;</span>
                <div class="text" @click.stop>
                    <p>Thank you for updating your status. The next step in your process will be to have a meeting with John Robertson, Head of Admissions, who will guide you through the next steps of the process.</p>
                    <p>He will be reaching out to you in the next 48 hours to set a meeting time. If you'd like to reach out to him directly, his email is <a href="mailto:john@tttc.ca">john@tttc.ca</a>.</p>
                </div>
            </div>
        </div>

    </section>
</template>
<script>
import paths from '../services/paths';
import mentors from '../services/mentors';
import users from '../services/users';
import aws from '../services/aws';
import courses from '../services/courses';
import finalProjects from '../services/final-projects';


import axios from 'axios';
import moment from 'moment';
import toastr from 'toastr';

export default {
    props:['userId','currentTerm'],
    data() {
        return {    
            loaded: false,                    
            projects: null,
            programs: [],
            programId: null,
            showOverlay: false,
            loading: false,
            path: null,
            pathName: null,
            focus: null,
            focusName: null,
            metrics: null,
            documents: [],
            enrollmentLetters: [],
            extraEnrollmentLetters:0,
            selectedTerms: [],
            selectedAssignments: [],
            newStatus: { hasReadPolicy:false, status: null, reason: null, intake: null, documents: null, dropping: null, softwareRequired: false },
            status: null,
            pastStatuses: null,
            statusChanged: false,
            statuses: [{ value: 'continuing', label: 'Continue On' }, { value: 'deferring', label: 'Defer Next Term' }, { value: 'dropping', label: 'Drop' }, { value: 'retaking', label: 'Retake This Term' }],
            intakes: [],
            showStatusChangePopup: false,
            zoomAccountConnected: null        
        }
    },
    components: {

    },
    async mounted() {
        this.getMentor();
        await this.getUser();
        this.getPathsAndFocuses();
        this.setIntakes();
        this.getDocuments();
        this.getPrograms();
        if (localStorage.roles.includes('Student'))
            this.getProjects();
    },
    methods: {
        getPrograms() {
            courses.getPrograms().then((response)=>{
                this.programs = response.data.programs;
            });
        },
        getProgramName(id) {
            const program = this.programs.find(p => p.id === id);
            if (program) {
                return program.name;
            }
        },
        downloadSlip(doc) {            
            users.getDocument(doc);
        },
        getDocuments() {
            users.getDocuments().then((response) => {
                this.documents = response.data;
            });
        },
        getKey(num, useLegalName) {
            let name;
            if (useLegalName) {
                name = localStorage.legal_name;
            } else {
                name = localStorage.user_name;
            }

            let key = name + '_Think_Tank_Online_Enrollment_Letter_'+localStorage.account_id;
            
            if (num && num > 1) {
                key += '_'+ parseInt(num);
            }
            key += '.pdf';

            key = key.replace(/ /g, '_');

            return key;
        },
        async downloadLetter(url) {
            function containsUUID(str) {
              const uuidRegex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;
              return uuidRegex.test(str);
            }

            let options;
            let deepObject = true;
            
            url = url.replace('https://tto-welcome-letters.s3.ca-central-1.amazonaws.com/','');
            const fragments = url.split('/');
            
            if (!containsUUID(url)) {
                if (fragments.length === 1) {
                    options = {
                        bucket: 'tto-welcome-letters',                    
                        object: fragments[0],
                        region: 'ca-central-1'
                    }  
                    deepObject = false;
                } else {
                    options = {
                        bucket: 'tto-welcome-letters',
                        folder: fragments[0],
                        object: fragments[1],
                        region: 'ca-central-1'
                    }  
                }
            }
            else  {
                options = {
                    bucket: 'tto-welcome-letters',
                    folder: fragments[0] + '/' + fragments[1],
                    object: fragments[2],
                    region: 'ca-central-1'
                }  
            }        
            if (deepObject === true) {
                const letter = await aws.getDeepObject(options);
                window.open(letter.data.url,'_blank');
                return;
            } else {
                
                const letter = await aws.getPresignedUrl(this, options.bucket, options.object, 'getObject');                
                window.open(letter.data,'_blank');
                return;
            }
        },   
      
        async downloadEnrollmentLetter(num) {
            let key = this.getKey(num, false);
            let url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'headObject');

            try {
                await axios.get(url.data);
                url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'getObject');
            } catch(e) {
                key = this.getKey(num, true);
                url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'getObject');
            }                       
            
            window.open(url.data,'_blank')
        },
        checkAvailability(e) {
            if (!this.allowed) {
                e.preventDefault();
                this.showOverlay = true;
            }
        },
        usesNewMarkingSystem(mark) {
            return !mark.video;
        },
        letterGrade(mark) {
            if (mark >= 97) return 'A+';
            if (mark >= 93) return 'A';
            if (mark >= 90) return 'A-';
            if (mark >= 87) return 'B+';
            if (mark >= 83) return 'B';
            if (mark >= 80) return 'B-';
            if (mark >= 77) return 'C+';
            if (mark >= 73) return 'C';
            if (mark >= 70) return 'C-';
            if (mark >= 67) return 'D+';
            if (mark >= 63) return 'D';
            if (mark >= 60) return 'D-';
            if (mark < 60) return 'F';
            return 'Incomplete';

        },
        getTranscript(enrollment) {
            var self = this;
            this.$store.dispatch('toggle', { type: 'loading', boolean: true });
            let userId = localStorage.user_id;

            if (localStorage.roles.includes('OnlineDirector')) {
                userId = parseInt(this.userId);
            }
            
            let filename = localStorage.user_name.replace(/ /g, '_');

            filename += '_Think_Tank_Online_Transcript_'+ enrollment.program.name.replace(/ /g, '_');

            filename += '.pdf';

            users.getTranscript(this, userId, enrollment.id, filename).then((response) => {
                this.$store.dispatch('toggle', { type: 'loading', boolean: false });
            });
        },

        // getTranscript(url) {
        //     const filename = url.split('/').pop();            
                    
        //     aws.getPresignedUrl(this, 'tto-transcripts', filename, 'getObject').then(function(presignedUrl) {
        //         window.open(presignedUrl.data);
        //     });

        // },
        downloadDocument(url) {
            let filename = url.replace('https://s3-us-west-2.amazonaws.com/ttto-supporting-documents/', '').replace(/\+/g, ' ');

            aws.getPresignedUrl(this, 'ttto-supporting-documents', filename, 'getObject').then(function(presignedUrl) {
                window.open(presignedUrl.data);
            });

        },

        setIntakes() {
            let intakes = [];
            let cutoff;

            if (this.currentTerm) {
                cutoff = this.currentTerm.startDate;
            } else {
                cutoff = this.$store.getters.currentTerm.startDate
            }

            cutoff = moment(cutoff).subtract(1,'week').toDate();

            const currentMonth = cutoff.getMonth();
            const currentYear = cutoff.getFullYear();
            for (let i = 0; i < 4; i++) {
                intakes.push({ date: currentYear + i + '-02-01', label: 'February ' + (currentYear + i) });
                intakes.push({ date: currentYear + i + '-06-01', label: 'June ' + (currentYear + i) });
                intakes.push({ date: currentYear + i + '-10-01', label: 'October ' + (currentYear + i) });
            }
            intakes = intakes.filter(function(i) { return moment(i.date).toDate() > cutoff });
            this.intakes = intakes;
        },
        getUser() {
            return users.getMe(this, this.userId).then((response) => {

                const student = response.data.person;
                
                this.zoomAccountConnected = student.zoomId && student.zoomAccountActivated && student.zoomPlan == '576460752303423488';

                this.extraEnrollmentLetters = student.upsells;
                if (student.letters) {
                    this.enrollmentLetters = student.letters.filter(l => l.type === 'enrollment_letter');
                }                

                
                const selectedEnrollment = student.enrollments.find(e => e.id === parseInt(localStorage.enrollment));
                if (selectedEnrollment) {
                    this.path = selectedEnrollment.path;                
                    this.focus = selectedEnrollment.focus;
                    this.programId = selectedEnrollment.programId;
                }

                if (student.student_statuses.length === 0) { // this is a demo user that was not set up right
                    student.student_statuses = [{status: 'unknown'}]
                }

                this.status = student.student_statuses[0].status;                
                this.pastStatuses = student.student_statuses;

                if (student.marks && student.marks.length > 0) {
                    if (selectedEnrollment) {
                    this.metrics = student.marks
                        .filter(m => selectedEnrollment.termIds.includes(m.marks.term.id))
                        .sort((a, b) => { return new Date(a.marks.term.startDate) - new Date(b.marks.term.startDate) })
                        .map((m) => {
                            if (m.mark_overrides && m.mark_overrides.length > 0) {
                                let overrides = m.mark_overrides.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                                m.marks = overrides[0].marks;
                                m.overridden = true;
                            }
                            return m.marks;
                        });
                    } else {
                        this.metrics = student.marks
                        .sort((a, b) => { return new Date(a.marks.term.startDate) - new Date(b.marks.term.startDate) })
                        .map((m) => {
                            if (m.mark_overrides && m.mark_overrides.length > 0) {
                                let overrides = m.mark_overrides.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                                m.marks = overrides[0].marks;
                                m.overridden = true;
                            }
                            return m.marks;
                        });                
                    }
                }
                this.loaded = true;
                return true;
            });
        },
        toggleTerm(id) {
            let index = this.selectedTerms.indexOf(id);
            index > -1 ? this.selectedTerms.splice(index, 1) : this.selectedTerms.push(id);
        },
        toggleAssignments(id) {
            let index = this.selectedAssignments.indexOf(id);
            index > -1 ? this.selectedAssignments.splice(index, 1) : this.selectedAssignments.push(id);
        },
        
        getPathsAndFocuses() {

            paths.getPaths(true).then((allPaths) => {
                allPaths.forEach((path) => {
                    if (this.path && this.path == path.id) {
                        this.pathName = path.name;
                    }
                    if (this.focus && this.focus == path.id) {
                        this.focusName = path.name;
                    }
                })
            });
        },

        async getMentor() {
            let requests = await mentors.getRequests(this.userId);
            let finalized = requests.data.requests.find((r) => {

                return r.approvedByMentor && r.approvedByStudent && r.studentId == parseInt(localStorage.user_id);
            });
            console.log(requests.data)

            if (finalized && finalized.mentor) {
                this.mentorName = finalized.mentor.firstName + ' ' + finalized.mentor.lastName;
            }
        },       
        getProjects() {
            var self = this;
            return finalProjects.get().then(function(response) {
                // console.log(response.data)
                self.projects = response.data.projects.sort(function(a,b) { return new Date(a.createdAt) - new Date(b.createdAt)});
                self.latestSubmission = self.projects[self.projects.length - 1];
                self.$forceUpdate();
                return true;
            })
        },

    },
    computed: {
        enrollments() {
            return this.$store.getters.enrollments;
        },
        selectedEnrollment() {
            return this.enrollments.find(e => e.id === parseInt(localStorage.enrollment));
        },
       
        allowed() {
            if (this.$store.getters.settings) {
                const setting = this.$store.getters.settings.find((s)=> { return s.name === 'statusChangesAllowed'});
                return setting.value;
            }
            return false;
        },
    }
}

</script>
<style lang="scss">
    .diploma-links {
        a {
            margin-right:1rem;
        }
    }
    .policy ul {
      list-style: disc!important;
      padding-left:4rem;
    }

    table.refund-policy {
        margin-bottom:2rem;
        .bold {
            font-weight:700;
        }
        td {
            border:1px solid #ccc;
            padding:18px 12px;
            vertical-align:top;
        }
        ul {
            padding-left:2rem;
        }
        .second-level {
            padding-left:4rem;
            li {
                list-style-type:circle;
            }
        }
    }

</style>
<style lang="scss" scoped>

.warning {
    padding:1.4rem 0;
}
.overlay {
    background:rgba(0,0,0,.6);
    z-index:999999999;
    display:flex;
    align-items:center;
    justify-content:center;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

.not-allowed {
    background: #222222;
    border: 1px solid #b0b0b0;
    color: #b0b0b0;
    font-size:14px;
    position: relative;
    width: 400px;
    padding:1rem;
    padding-right:6rem;
    .close {
        position: absolute;
        top:-2px;
        right:1px;
        font-weight:400;
        cursor:pointer;
    }
}

.policy {
    margin:1rem 0;

    label {

        input {
            cursor:pointer;
            margin-right:.5rem;
        }
    }
}


label {
    font-size: 1.25em;
}

.bold {
    font-weight: 700;
}

.download-transcript {
    margin-bottom: .5rem;

    & > div {
        color: #3cf;
        cursor: pointer;
    }
}

table.past-statuses {

    a {
        display: block;
        white-space: nowrap;
    }
}

@keyframes pulse {
    from {
        transform: scale3d(1, 1, 1);
    }

    50% {
        transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
        transform: scale3d(1, 1, 1);
    }
}

.loading {
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: pulse;
    margin: 10rem 0;
}

.highlight {
    font-weight: 400;
    color: #3cf;
}

.indent {
    padding-left: 3rem;

    &.payments {
        margin-left: -1rem;
    }
}

.mark {
    background: initial;
    float: right;
    display: block;
}

form {
    padding: 2rem;
}

div.documents {
    margin-top: 2rem;
}

label.documents {
    border: 1px solid #b0b0b0;
    padding: .5rem 1rem;

    input {
        display: none;
    }
}

textarea.form-control {
    border: 1px solid #b0b0b0 !important;
    height: 10rem;
}

.zoom-status {
    display:flex;
    gap: 1rem;
    align-items:center;        
    background: #1a1a1a;
    display:inline-flex;
    padding: .5rem 1rem;
    .indicator {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
        &.red {
            background: #FF2400;
        
        }
        &.green {
            background: #32CD32;
        
        }
    }
}

.metrics-container {

    //        border:1px solid #b0b0b0;
    .term-metrics:last-child .term-header {
        border-bottom: 1px solid #b0b0b0;
    }

    i {
        cursor: pointer;
    }
}

.term-metrics {
    .term-header {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        border-bottom: none;
        cursor: pointer;
        font-size: 1.2em;
        font-weight: bold;

        .total-mark {
            float: right;
        }
    }

    .metrics {
        padding: 1rem;
        border: 1px solid #b0b0b0;
    }

    .submissions {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        margin: 1rem -1rem;

        &>div {
            border-bottom: 1px solid #b0b0b0;
            padding: .5rem 0;
        }

        &>div:last-child {
            border-bottom: none;
        }
    }
}

.payments {
    display: flex;

    span {
        width: 50px;
        padding: 1rem;
    }
}

.status-wrapper {
    display: flex;

    label {
        padding-top: 1rem;
    }

    select {
        margin-left: 1rem;
        padding: .5rem 1rem;
        height: auto;
        margin-top: .5rem;
    }
}

.status {
    .controls {
        display: flex;
        margin-bottom: 1rem;

        .continuing {
            background: #9ed4b5 !important;
            color: #1a1a1a;
        }

        .deferring {
            background: #ff9e4a !important;
            color: #1a1a1a;
        }

        .dropping {
            background: #ffffff !important;
            color: #1a1a1a;
        }

        .retaking {
            background: #add0f5 !important;
            color: #1a1a1a;
        }
    }

    button {
        padding: .5rem;
        margin-top: 1rem;
    }
}
a.enrollment-letter {
    display:block;
    margin-bottom:.5rem;
}

</style>



// WEBPACK FOOTER //
// Status.vue?37c56453